import { TranslateService } from '@ngx-translate/core';
import { API_CONSTANT } from './services/api.constant';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
var AppComponent = (function () {
    function AppComponent(httpClient, translateService) {
        var _this = this;
        this.httpClient = httpClient;
        this.translateService = translateService;
        this.title = 'app';
        this.defaultLang = 'en';
        this.navbarActive = false;
        if (localStorage.getItem('lang')) {
            this.defaultLang = localStorage.getItem('lang');
        }
        translateService.setDefaultLang('en');
        translateService.use(this.defaultLang);
        httpClient.get(API_CONSTANT.feature_flag).subscribe(function (response) {
            environment.enabledCustomerRequest = response.enabled_customer_request;
            _this.navbarActive = true;
        });
    }
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.ts.pre-build-optimizer.js